import React, { Component } from 'react'
import $ from '../../utils/jquery'
import dotProp from 'dot-prop-immutable'
import classNames from 'classnames'

export default class Item extends Component {
  constructor(props) {
    super(props);

    this.state = {
      item: this.props.item,
      submitting: false,
      dirty: false,
      deleted: false,
    }
  }

  onChange = (ev) => this.updateItem('comment', ev.target.value)

  updateItem = (path, val, callback) => {
    this.setState({
      item: dotProp.set(this.state.item, path, val),
      dirty: true
    }, callback)
  }

  statusButtons = () => {
    const types = ['approved', 'pending']
    return types.map(
      type => {
        const btnClass = (this.state.item.status === type) ? 'warning' : 'default'
        return (
          <button 
            key={type}
            className={`btn btn-sm btn-${btnClass}`}
            onClick={() => this.updateItem('status', type, this.save)}
          > 
            {type} 
          </button>
        )
      }
    )
  }

  classNames = () => classNames(
    'item',
    {
      dirty: this.state.dirty,
      submitting: this.state.submitting,
      deleted: this.state.deleted,
    }
  )

  delete = () => {
    this.setState({submitting: true})

    $.ajax(
      {
        url: `/how_use_items/${this.props.item.id}/`,
        type: 'DELETE',
        xhrFields: { withCredentials: true }
      }
    )
    .done( (data, textStatus) => {
      if (textStatus === 'success') {
        this.setState({deleted: true})
        window.app.utils.notify('deleted', 'success');
      }
    })
    .fail( (jqXHR) => window.app.utils.notify('error', 'error') )
    .always( () => this.setState({submitting: false}) )
  }

  save = () => {
    this.setState({submitting: true})

    $.ajax(
      {
        url: `/how_use_items/${this.props.item.id}/`,
        type: 'PATCH',
        data: {
          how_use_item: this.state.item
        },
        xhrFields: { withCredentials: true }
      }
    )
    .done( (data, textStatus) => {
      if (textStatus === 'success') {
        this.setState({dirty: false})
        window.app.utils.notify('saved', 'success');
      }
    })
    .fail( (jqXHR) => window.app.utils.notify('error', 'error') )
    .always( () => this.setState({submitting: false}) )
  }

  render = () => {
    return (
      <div className={this.classNames()}>
        <div className="buttons">
          { this.statusButtons() }
          
          <button 
            className='btn btn-sm btn-primary'
            onClick={this.save}
          > 
            <i className='fa-solid fa-save'/>
          </button>
          {' '}
          <button 
            className='btn btn-sm btn-danger'
            onClick={this.delete}
          > 
            <i className='fa-solid fa-trash'/>
          </button>
          {' '}
          <span>{this.state.item.site_id}</span>
          {' '}
          <span>{this.state.item.context}</span>
        </div>

        <div className="inputs">
          <input
            className='form-control'
            value={this.state.item.comment}
            onChange={this.onChange}
          />
        </div>
      </div>
    )
  }
}

